import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from "@/plugins/axios"
// elemenetplus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'swiper/swiper-bundle.css';
// css
import '@/styles/index.css'
router.beforeEach((to, from, next) => {
  // 这句话会导致原页面回滚到最上面
  if (to.meta.title) {
    document.title = to.meta.title
  }
  console.log(from.name)
  console.log(to.name)
  // 检查是否需要在新标签页打开
  if (to.meta.openInNewTab && from.name) {
    // console.log("新")
    // 获取完整URL
    const baseUrl = window.location.origin
    const fullUrl = baseUrl + to.fullPath
    window.open(fullUrl, '_blank')
    // 阻止当前页面跳转
    next(false)
    return
  } else {
    // console.log("老")
    next()
  }
  
})
const app = createApp(App);
app.use(store)
  .use(router)
  .use(axios, { router, store, opt: "VE_API" })
  .use(ElementPlus)
  .mount('#app')
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}